import { filter, set } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';
// components
import { ProductivityweekcelebrationsListHead, ProductivityweekcelebrationsListToolbar, ProductivityweekcelebrationsMoreMenu } from '../sections/reports';

import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'title', label: 'Title', alignRight: false },
  { id: 'startingdate', label: 'Startingdate', alignRight: false },
  { id: 'endingdate', label: 'Endingdate', alignRight: false },
  { id: 'month', label: 'Month', alignRight: false },
  { id: 'year', label: 'Year', alignRight: false },
  { id: 'onedaytraining', label: 'Onedaytraining', alignRight: false },
  { id: 'webinar', label: 'Webinar', alignRight: false },
  { id: 'image', label: 'Image', alignRight: false },
  { id: 'images', label: 'Multiple Images', alignRight: false },
  { id: 'form', label: 'Form Links', alignRight: false },
  { id: 'eventDateTime', label: 'Event Date & Time', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, roleFilter) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  let filteredArray = stabilizedThis.map((el) => el[0]);

  // Apply text query filter
  if (query) {
    filteredArray = filteredArray.filter((productivityweekcelebrations) => {
      if (
        productivityweekcelebrations.month.toLowerCase().includes(query.toLowerCase()) ||
        productivityweekcelebrations.year.toString().includes(query) ||
        productivityweekcelebrations.training.toLowerCase().includes(query.toLowerCase()) ||
        productivityweekcelebrations.material.toLowerCase().includes(query.toLowerCase())
      ) {
        return productivityweekcelebrations;
      }
      return null;
    }
    )
  }

  // Apply role filter
  if (roleFilter) {
    filteredArray = filteredArray.filter((productivityweekcelebrations) =>
      productivityweekcelebrations.role.toLowerCase() === roleFilter.toLowerCase()
    );
  }

  return filteredArray;
}

export default function Productivityweekcelebrations() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('email'); // Default sort by email
  const [filterName, setFilterName] = useState('');
  const [roleFilter, setRoleFilter] = useState(''); // State for role filter
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // State for Productivityweekcelebrations
  const [productivityweekcelebrations, setProductivityweekcelebrations] = useState([]);
  const [editingproductivityweekcelebrationsId, setEditingProductivityweekcelebrationsId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [startingdate, setStartingdate] = useState('');
  const [endingdate, setEndingdate] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [onedaytraining, setOnedaytraining] = useState('');
  const [webinar, setWebinar] = useState('');
  const [image, setImage] = useState('');
  const [images, setImages] = useState([]);
  const [form, setForm] = useState([]);
  const [title, setTitle] = useState('');
  const [selectedproductivityweekcelebrations, setSelectedProductivityweekcelebrations] = useState(null);
  const [viewModalOpen, setViewModalOpen] = useState(false);
 const [eventDateTime, setEventDateTime] = useState('');



  // Fetch Productivityweekcelebrations from the server on component mount
  useEffect(() => {
    fetchproductivityweekcelebrations();
  }, []);

  // Fetch Productivityweekcelebrations from the server
  const fetchproductivityweekcelebrations = async () => {
    try {
      const response = await axios.get('https://cpccbe.org/api/productivityweekcelebrations/getall', { startingdate, endingdate, month, year, onedaytraining, webinar, image, eventDateTime }); // Adjust endpoint as necessary ;
      console.log(response);
      setProductivityweekcelebrations(response.data || []);
    } catch (error) {
      console.error("Error fetching Productivityweekcelebrations:", error);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = productivityweekcelebrations.map((n) => n.email); // Use email as unique identifier
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, email) => {
    const selectedIndex = selected.indexOf(email);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, email);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // Handle opening and closing of modal for editing trainingPrograms
  const handleOpenModal = (productivityweekcelebrationsId) => {
    if (productivityweekcelebrationsId) {

      const productivityweekcelebrationstoEdit = productivityweekcelebrations.find(productivityweekcelebrations => productivityweekcelebrations._id === productivityweekcelebrationsId);
      if (productivityweekcelebrationstoEdit) {
setStartingdate(productivityweekcelebrationstoEdit.startingdate.split('T')[0]);
setEndingdate(productivityweekcelebrationstoEdit.endingdate.split('T')[0]);

        setMonth(productivityweekcelebrationstoEdit.month);
        setYear(productivityweekcelebrationstoEdit.year);
        setOnedaytraining(productivityweekcelebrationstoEdit.onedaytraining);
        setWebinar(productivityweekcelebrationstoEdit.webinar);
        setImage(productivityweekcelebrationstoEdit.image);
        setImages(productivityweekcelebrationstoEdit.images || []);
        setForm(productivityweekcelebrationstoEdit.form || []);
        setTitle(productivityweekcelebrationstoEdit.title || '');
        
if (productivityweekcelebrationstoEdit.eventDateTime) {
  const date = new Date(productivityweekcelebrationstoEdit.eventDateTime);
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60000);
  setEventDateTime(localDate.toISOString().slice(0, 16));
} else {
  setEventDateTime('');
}
        setEditingProductivityweekcelebrationsId(productivityweekcelebrationsId);
      }
    } else {
      setStartingdate('');
      setEndingdate('');
      setMonth('');
      setYear('');
      setOnedaytraining('');
      setWebinar('');
      setImage('');
      setImages([]);
      setForm([]);
      setTitle('');
      setEventDateTime('');
      setEditingProductivityweekcelebrationsId(null);
    }
    setOpenModal(true);

  };


  const handleCloseModal = () => {
    setOpenModal(false);
    setStartingdate('');
    setEndingdate('');
    setMonth('');
    setYear('');
    setOnedaytraining('');
    setWebinar('');
    setImage('');
    setImages([]);
    setForm([]);
    setTitle('');
    setEventDateTime('');
    setEditingProductivityweekcelebrationsId(null);

  };



  // Handle adding a new Productivityweekcelebrations
  const handleAddProductivityweekcelebrations = async () => {
    try {
      const response = await axios.post('https://cpccbe.org/api/productivityweekcelebrations/createProductivityweek', { startingdate, endingdate, month, year, onedaytraining, webinar, image, images, form, title, eventDateTime }); // Adjust based on your actual data structure
      fetchproductivityweekcelebrations(); // Refresh productivityweekcelebrations list after adding
      handleCloseModal(); // Close modal after adding
    } catch (error) {
      console.error("Error adding productivityweekcelebrations:", error);
    }
  };

  // Handle updating a productivityweekcelebrations
  const handleUpdateproductivityweekcelebrations = async () => {
    try {
      await axios.patch(`https://cpccbe.org/api/productivityweekcelebrations/update/${editingproductivityweekcelebrationsId}`, { startingdate, endingdate, month, year, onedaytraining, webinar, image, images, form, title, eventDateTime }); // Adjust endpoint as necessary
      fetchproductivityweekcelebrations(); // Refresh productivityweekcelebrations list after updating
      handleCloseModal(); // Close modal after updating
    } catch (error) {
      console.error("Error updating productivityweekcelebrations:", error);
    }
  };

  // Handle deleting a productivityweekcelebrations
  const handleDeleteproductivityweekcelebrations = async (productivityweekcelebrationsId) => {
    if (window.confirm("Are you sure you want to delete this productivityweekcelebrations?")) {
      try {
        await axios.delete(`https://cpccbe.org/api/productivityweekcelebrations/delete/${productivityweekcelebrationsId}`); // Adjust endpoint as necessary

        fetchproductivityweekcelebrations(); // Refresh trainingPrograms list after deletion
      } catch (error) {
        console.error("Error deleting productivityweekcelebrations:", error);
      }
    }
  };

  const handleViewproductivityweekcelebrations = (productivityweekcelebrations) => {
    // Open a modal or set state to display productivityweekcelebrations details
    setSelectedProductivityweekcelebrations(productivityweekcelebrations); // Assuming you have state to hold selected productivityweekcelebrations data
    setViewModalOpen(true); // Open the modal for viewing trainingPrograms details
  };




  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - productivityweekcelebrations.length) : 0;

  // Apply sorting and filtering
  const filteredproductivityweekcelebrations = applySortFilter(productivityweekcelebrations, getComparator(order, orderBy), filterName, roleFilter);


  const isproductivityweekcelebrationsNotFound = filteredproductivityweekcelebrations.length === 0;

  return (
    <Page title="productivityweekcelebrations">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Productivity week celebrations
          </Typography>
          <Button variant="contained" onClick={handleOpenModal} startIcon={<Iconify icon="eva:plus-fill" />}>
            New Productivity week celebrations
          </Button>
        </Stack>

        <Card>
          <ProductivityweekcelebrationsListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            roleFilter={roleFilter}
            onRoleFilterChange={(e) => setRoleFilter(e.target.value)}
          />


          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ProductivityweekcelebrationsListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={productivityweekcelebrations.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredproductivityweekcelebrations.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { _id, startingdate, endingdate, month, year, onedaytraining, webinar, image, title, images, form,eventDateTime } = row; // Adjust based on your actual data structure
                    const isItemSelected = selected.indexOf(month) !== -1;

                    return (
                      <TableRow
                        hover
                        key={_id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell align="left">
                          <IconButton onClick={() => handleViewproductivityweekcelebrations(row)} aria-label="view productivityweekcelebrations">
                            <Iconify icon="eva:eye-fill" />
                          </IconButton>
                        </TableCell>
                        <TableCell align="left">{title || "Productivity Week"}</TableCell>
<TableCell align="left">
  {new Date(startingdate).toLocaleDateString()}
</TableCell>

<TableCell align="left">
  {new Date(endingdate).toLocaleDateString()}
</TableCell>

                        <TableCell align="left">{month}</TableCell>
                        <TableCell align="left">{year}</TableCell>
                        <TableCell align="left">{onedaytraining}</TableCell>
                        <TableCell align="left">{webinar}</TableCell>
                        <TableCell align="left">{image}</TableCell>
                        <TableCell align="left">{images ? images.length : 0}</TableCell>
                        <TableCell align="left">{form ? form.length : 0}</TableCell>
                        <TableCell align="left">{eventDateTime ? new Date(eventDateTime).toLocaleString() : 'N/A'}</TableCell>
                        <TableCell align="left">
                          <ProductivityweekcelebrationsMoreMenu
                            onEdit={() => handleOpenModal(row._id)}
                            onDelete={() => handleDeleteproductivityweekcelebrations(row._id)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isproductivityweekcelebrationsNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={productivityweekcelebrations.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        {/* Modal for Editing productivityweekcelebrations */}
        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>{editingproductivityweekcelebrationsId ? "Edit Productivity week celebrations" : "Add New Productivity week celebrations"}</DialogTitle>
          <DialogContent>
<TextField
  margin="dense"
  id="startingdate"
  label="Starting Date"
  type="date"
  fullWidth
  InputLabelProps={{ shrink: true }}
  value={startingdate ? startingdate.split('T')[0] : ''}
  onChange={(e) => setStartingdate(e.target.value)}
/>

            <TextField
              margin="dense"
              id="endingdate"
              label="Ending Date"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={endingdate ? endingdate.split('T')[0] : ''}
              onChange={(e) => setEndingdate(e.target.value)}
            />
            <TextField
              margin="dense"
              id="month"
              label="Month"
              type="text"
              fullWidth
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            />
            <TextField
              margin="dense"
              id="year"
              label="Year"
              type="text"
              fullWidth
              value={year}
              onChange={(e) => setYear(e.target.value)}
            />
            <TextField
              margin="dense"
              id="onedaytraining"
              label="Onedaytraining"
              type="text"
              fullWidth
              value={onedaytraining}
              onChange={(e) => setOnedaytraining(e.target.value)}
            />
            <TextField
              margin="dense"
              id="webinar"
              label="Webinar"
              type="text"
              fullWidth
              value={webinar}
              onChange={(e) => setWebinar(e.target.value)}
            />
            <TextField
              margin="dense"
              id="title"
              label="Title"
              type="text"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <TextField
              margin="dense"
              id="image"
              label="Main Image URL"
              type="text"
              fullWidth
              value={image}
              onChange={(e) => setImage(e.target.value)}
            />
            <TextField
              margin="dense"
              id="images"
              label="Additional Image URLs (comma separated)"
              type="text"
              fullWidth
              value={images.join(', ')}
              onChange={(e) => setImages(e.target.value.split(',').map(s => s.trim()))}
            />
            <TextField
              margin="dense"
              id="form"
              label="Form Links / Registration URLs (comma separated)"
              type="text"
              fullWidth
              value={form.join(', ')}
              onChange={(e) => setForm(e.target.value.split(',').map(s => s.trim()))}
            />
            <TextField
  margin="dense"
  label="Event Date & Time"
  type="datetime-local"
  fullWidth
  value={eventDateTime}
  onChange={(e) => setEventDateTime(e.target.value)}
  InputLabelProps={{
    shrink: true,
  }}
/>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal}>Cancel</Button>
            {editingproductivityweekcelebrationsId ? (
              <Button onClick={handleUpdateproductivityweekcelebrations}>Update Productivity week celebrations</Button>
            ) : (
              <Button onClick={handleAddProductivityweekcelebrations}>Add Productivity week celebrations</Button>
            )}
          </DialogActions>
        </Dialog>

        <Dialog open={viewModalOpen} onClose={() => setViewModalOpen(false)}>
          <DialogTitle>Productivity week celebrations Details</DialogTitle>
          <DialogContent>
  <TextField
  margin="dense"
  label="Starting Date"
  type="date"
  fullWidth
  InputLabelProps={{ shrink: true }}
  value={
    selectedproductivityweekcelebrations?.startingdate
      ? new Date(selectedproductivityweekcelebrations.startingdate)
          .toISOString()
          .split('T')[0]
      : ''
  }
  disabled
/>

<TextField
  margin="dense"
  label="Ending Date"
  type="date"
  fullWidth
  InputLabelProps={{ shrink: true }}
  value={
    selectedproductivityweekcelebrations?.endingdate
      ? new Date(selectedproductivityweekcelebrations.endingdate)
          .toISOString()
          .split('T')[0]
      : ''
  }
  disabled
/>
            <TextField
              margin="dense"
              id="month"
              label="Month"
              type="text"
              fullWidth
              value={selectedproductivityweekcelebrations?.month}
              disabled
            />
            <TextField
              margin="dense"
              id="year"
              label="Year"
              type="text"
              fullWidth
              value={selectedproductivityweekcelebrations?.year}
              disabled
            />
            <TextField
              margin="dense"
              id="onedaytraining"
              label="Onedaytraining"
              type="text"
              fullWidth
              value={selectedproductivityweekcelebrations?.onedaytraining}
              disabled
            />
            <TextField
              margin="dense"
              id="webinar"
              label="Webinar"
              type="text"
              fullWidth
              value={selectedproductivityweekcelebrations?.webinar}
              disabled
            />
            <TextField
              margin="dense"
              id="image"
              label="Image"
              type="text"
              fullWidth
              value={selectedproductivityweekcelebrations?.image}
              disabled
            />
            <TextField
              margin="dense"
              id="title"
              label="Title"
              type="text"
              fullWidth
              value={selectedproductivityweekcelebrations?.title}
              disabled
            />
            <TextField
              margin="dense"
              id="images"
              label="Additional Images"
              type="text"
              fullWidth
              value={selectedproductivityweekcelebrations?.images?.join(', ')}
              disabled
            />
            <TextField
              margin="dense"
              id="form"
              label="Form Links"
              type="text"
              fullWidth
              value={selectedproductivityweekcelebrations?.form?.join(', ')}
              disabled
            />
                            <TextField
                              label="Event Date & Time"
                              value={selectedproductivityweekcelebrations?.eventDateTime ? new Date(selectedproductivityweekcelebrations.eventDateTime).toLocaleString() : 'N/A'}
                              margin="dense"
                              InputProps={{
                                readOnly: true,
                              }}
                              fullWidth
                              variant="outlined"
                            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setViewModalOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>


      </Container>
    </Page>
  );
}
